import { entityAPI } from "api/GenericAPI";
import { apiClient } from "api/APIClient";

import { Address, Person } from "./CommunityInterfaces";
import { UnifiedInteractionLog } from "./CommunityInterfaces";

// ================== Generic API ==================
export const addressesAPI = entityAPI<Address>("community", "address");

export const getAllInteractionLogsByAddress = async (
  addressId: number
): Promise<UnifiedInteractionLog[]> => {
  const { data } = await apiClient.get<UnifiedInteractionLog[]>(
    `/interactions/addresses/${addressId}/logs/all/`
  );
  return data;
};


export const getPeopleByAddress = async (
  addressId: number
): Promise<Person[]> => {
  const { data } = await apiClient.get<Person[]>(
    `/community/addresses/${addressId}/people/`
  );
  return data;
};
